(function () {
  'use strict';

  var forms = document.querySelectorAll('[data-home-news-form]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var wrap = form.closest('[data-home-news-wrap]');
    var input = form.querySelector('[data-home-news-input]');
    var submit = form.querySelector('[data-home-news-submit]');
    var feedback = form.querySelector('[data-home-news-feedback]');
    var honeypot = form.querySelector('input[name="contact[website_url]"]');

    if (!wrap || !input || !submit || !feedback) return;

    var clearFeedback = function () {
      feedback.innerHTML = '';
    };

    var showFeedback = function (message, variant) {
      var span = document.createElement('span');
      span.className = 'home-news__feedback-item home-news__feedback-item--' + variant;
      if (variant === 'success') {
        span.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<path d="m3 8 3 3 7-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' + message;
      } else {
        span.textContent = message;
      }
      feedback.innerHTML = '';
      feedback.appendChild(span);
    };

    var setLoading = function (loading) {
      if (loading) {
        submit.setAttribute('data-home-news-loading', '');
        submit.disabled = true;
      } else {
        submit.removeAttribute('data-home-news-loading');
        submit.disabled = false;
      }
    };

    var setSuccess = function (message) {
      wrap.setAttribute('data-home-news-state', 'success');
      showFeedback(message, 'success');
    };

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (honeypot && honeypot.value) {
        setSuccess(form.dataset.successMessage || (window.shftdLocale && window.shftdLocale.newsletter_success) || "You're in. Watch your inbox.");
        return;
      }

      clearFeedback();
      setLoading(true);

      var formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          return response.text().then(function (text) {
            return { ok: response.ok, status: response.status, text: text };
          });
        })
        .then(function (result) {
          setLoading(false);

          var lowered = result.text ? result.text.toLowerCase() : '';

          var hasError =
            lowered.indexOf('errors') !== -1 &&
            lowered.indexOf('form-error') !== -1;

          if (result.ok && !hasError) {
            var successLabel = (feedback.querySelector('[data-home-news-ssr-success]') || {}).textContent;
            setSuccess(
              (successLabel && successLabel.trim()) ||
                (window.shftdLocale && window.shftdLocale.newsletter_success) || "You're in. Watch your inbox."
            );
            return;
          }

          if (lowered.indexOf('already') !== -1 && lowered.indexOf('subscribed') !== -1) {
            setSuccess((window.shftdLocale && window.shftdLocale.newsletter_already) || "You're already on the list.");
            return;
          }

          showFeedback(
            (window.shftdLocale && window.shftdLocale.newsletter_error) || 'Something went wrong. Please check your email and try again.',
            'error'
          );
        })
        .catch(function () {
          setLoading(false);
          showFeedback(
            (window.shftdLocale && window.shftdLocale.newsletter_offline) || "Couldn't reach the server. Please try again.",
            'error'
          );
        });
    });

    var ssrSuccess = feedback.querySelector('[data-home-news-ssr-success]');
    if (ssrSuccess) {
      wrap.setAttribute('data-home-news-state', 'success');
    }
  });
})();
